import { Card, CardContent, CardHeader, Stack } from '@mui/material';
import EmailDomains from './email-domains';
import { useTranslation } from 'react-i18next';
import SingleEmails from './single-emails';

const EmailSettings = () => {
    const { t } = useTranslation();

    return (
        <Stack spacing={2}>
            <Card sx={{ flex: 1 }}>
                <CardHeader title={t('Email Domains')} />
                <CardContent>
                    <EmailDomains />
                </CardContent>
            </Card>
            <Card sx={{ flex: 1 }}>
                <CardHeader title={t('Sender Emails')} />
                <CardContent>
                    <SingleEmails />
                </CardContent>
            </Card>
        </Stack>
    );
};

export default EmailSettings;
